import { Controller } from "@hotwired/stimulus"

// Rewrites a <time datetime="...UTC ISO8601..."> element's text in the
// browser's timezone, e.g. "Feb 3, 2026 at 4:37 PM". The server-rendered
// UTC label remains as the no-JS fallback (see Academy::CoursesHelper).
export default class extends Controller {
  connect() {
    const timestamp = new Date(this.element.getAttribute("datetime"))
    if (Number.isNaN(timestamp.getTime())) return

    this.element.textContent = this.format(timestamp)
  }

  format(timestamp) {
    const date = new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric"
    }).format(timestamp)
    const time = new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "2-digit"
    }).format(timestamp)
    return `${date} at ${time}`
  }
}
